import React from "react";
import "../../styles/Footer.css";
import LogoTwinexa from "../../assets/img/LogoTwinexa.png";
import { Fade } from "react-awesome-reveal";
import { TbBrandLinkedin, TbBrandInstagram, TbBrandWhatsapp, TbMail } from "react-icons/tb";

const YEAR = new Date().getFullYear();
const WA   = "5493512035657";
const wa   = (msg) => `https://wa.me/${WA}?text=${encodeURIComponent(msg)}`;

/* Smooth scroll helper */
const scrollTo = (id, offset = 80) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: "smooth" });
};

/* Mirrors Navbar NAV_ITEMS exactly */
const nosotros = [
  { label: "El Problema",        scrollId: "problema"    },
  { label: "Nuestra Identidad",  scrollId: "identidad"   },
  { label: "Metodología",        scrollId: "metodologia" },
];

const ecosistema = [
  { label: "ERP Industrial",      scrollId: "sol-erp" },
  { label: "MES",                 scrollId: "sol-mes" },
  { label: "Gemelo Digital",      scrollId: "sol-dt"  },
  { label: "Desarrollo a Medida", scrollId: "sol-dev" },
  { label: "IA para Empresas",    scrollId: "sol-ai"  },
];

const industria = [
  { label: "Indicadores 4.0",    scrollId: "indicadores" },
  { label: "Track Record",       scrollId: "clientes"    },
];

const tuEmpresa = [
  { label: "Tu Desafío",         scrollId: "desafio"  },
  { label: "Clientes",           scrollId: "clientes" },
  { label: "FAQ",                scrollId: "faq"      },
];

const social = [
  {
    label: "LinkedIn",
    icon: <TbBrandLinkedin size={20} />,
    href: "https://www.linkedin.com/company/twinexa",
  },
  {
    label: "Instagram",
    icon: <TbBrandInstagram size={20} />,
    href: "https://www.instagram.com/twinexaa/",
  },
  {
    label: "WhatsApp",
    icon: <TbBrandWhatsapp size={20} />,
    href: wa("Hola! Me comunico desde twinexa.com, me gustaría obtener más información."),
  },
  {
    label: "Email",
    icon: <TbMail size={20} />,
    href: "mailto:sales@twinexa.com",
  },
];

export const Footer = () => (
  <footer className="footer-root">

    {/* ── Shimmer top border ── */}
    <div className="footer-shimmer-border" />

    <div className="container">

      {/* ── Main grid ── */}
      <Fade direction="up" duration={700} triggerOnce>
        <div className="footer-grid">

          {/* Col 1 – Brand */}
          <div className="footer-brand">
            <img src={LogoTwinexa} alt="Twinexa" className="footer-logo" />
            <p className="footer-tagline">
              Digitalizamos, conectamos y automatizamos operaciones industriales y comerciales
              para que tomes mejores decisiones, más rápido.
            </p>
            <div className="footer-social">
              {social.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="footer-social-btn"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 – Nosotros */}
          <div className="footer-col">
            <h4 className="footer-col-title">Nosotros</h4>
            <ul className="footer-links">
              {nosotros.map((l) => (
                <li key={l.label}>
                  <button type="button" onClick={() => scrollTo(l.scrollId)}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 – Ecosistema */}
          <div className="footer-col">
            <h4 className="footer-col-title">Ecosistema</h4>
            <ul className="footer-links">
              {ecosistema.map((l) => (
                <li key={l.label}>
                  <button type="button" onClick={() => scrollTo(l.scrollId)}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 – Industria 4.0 */}
          <div className="footer-col">
            <h4 className="footer-col-title">Industria 4.0</h4>
            <ul className="footer-links">
              {industria.map((l) => (
                <li key={l.label}>
                  <button type="button" onClick={() => scrollTo(l.scrollId)}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 5 – Tu Empresa */}
          <div className="footer-col">
            <h4 className="footer-col-title">Tu Empresa</h4>
            <ul className="footer-links">
              {tuEmpresa.map((l) => (
                <li key={l.label}>
                  <button type="button" onClick={() => scrollTo(l.scrollId)}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 6 – Contacto */}
          <div className="footer-col">
            <h4 className="footer-col-title">Contacto</h4>
            <ul className="footer-links footer-contact">
              <li>
                <a href="mailto:sales@twinexa.com">sales@twinexa.com</a>
              </li>
              <li>
                <a
                  href={wa("Hola! Me comunico desde twinexa.com y quiero más información.")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WhatsApp directo
                </a>
              </li>
              <li>
                <a
                  href="https://calendly.com/twinexa-software/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-cta-link"
                >
                  → Agendar diagnóstico gratis
                </a>
              </li>
            </ul>
          </div>

        </div>
      </Fade>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <small className="footer-copy">
          © 2022 – {YEAR} Twinexa. Todos los derechos reservados.
        </small>
        <small className="footer-made">
          Forward for all 🚀
        </small>
      </div>

    </div>
  </footer>
);

export default Footer;
